<template>
  <el-dialog
    title="编辑资料"
    :close-on-click-modal="false"
    width="600px"
    :visible.sync="visible"
  >
    <el-form>
      <draggable class="el-draggable" v-model="materials">
        <el-form-item v-for="(mt, idx) in materials" :key="idx">
          <span style="margin-right: 1rem">{{ idx + 1 }}</span>
          <el-input
            placeholder="名称"
            style="width: 400px; margin-right: 10px"
            v-model.trim="mt.name"
          ></el-input>
          <!--<el-input
            placeholder="数量单位"
            style="width: 100px; margin-right: 10px"
            v-model.trim="mt.numUnit"
          ></el-input>-->
          <el-button
            type="text"
            size="mini"
            style="margin-left: 1rem"
            @click="del(mt, idx)"
            >删除</el-button
          >
          <tx-upload class="tx-upload" v-model="mt.file"></tx-upload>
        </el-form-item>
      </draggable>
    </el-form>
    <el-row>
      <el-col>
        <el-button plain @click="addOneline(1)">添加 1 行</el-button>
        <el-button plain @click="addOneline(3)">添加 3 行</el-button>
        <el-button plain @click="addOneline(5)">添加 5 行</el-button>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" :loading="loading"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data() {
    return {
      visible: false,
      loading: false,
      courseId: "",
      materials: [],
    };
  },
  methods: {
    del(mt, idx) {
      if (mt.id) {
        this.$confirm("确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl("course/material/delete"),
            method: "delete",
            data: mt.id,
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getMaterials(this.courseId);
          });
        });
      } else {
        if (idx > 0) {
          this.materials.splice(idx, 1);
        } else {
          this.materials[idx].name = "";
          // this.materials[idx].numUnit = "";
        }
      }
    },
    addOneline(count) {
      for (let i = 0; i < count; i++) {
        this.materials.push({
          name: "",
          // numUnit: "",
          courseId: this.courseId,
        });
      }
    },
    init(id) {
      this.courseId = id;
      this.visible = true;
      this.$nextTick(() => {
        if (id) {
          this.getMaterials(id);
        }
      });
    },
    getMaterials(id) {
      this.$http({
        url: this.$http.adornUrl(`/course/material/list`),
        method: "get",
        params: this.$http.adornParams({
          courseId: id,
          page: -1,
        }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const { totalCount, list } = data.page;
          if (totalCount < 1) {
            this.materials = list.concat({
              name: "",
              // numUnit: "",
              courseId: id,
            });
          } else {
            this.materials = list;
          }
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      const forms = this.materials.filter((i) => {
        return i.name
      });
      if (forms.length > 0) {
        forms.forEach((item, idx) => (item.sort = idx));
        this.loading = true;
        this.$http({
          url: this.$http.adornUrl(`course/material/multiSave`),
          method: "post",
          data: forms,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: `编辑成功`,
              type: "success",
            });
            this.visible = false;
            this.$emit("refreshDataList");
          } else {
            this.$message.error(data.msg);
          }
          this.loading = false;
          this.visible = false;
        });
      } else {
        this.$message.warning("您尚未填写物料！");
      }
    },
  },
};
</script>

<style lang="scss">
.el-draggable {
  .el-form {
    .el-form-item__content {
      .el-input {
        width: 200px;
      }
    }
  }
}
.tx-upload {
  margin-left: 1.4rem;
  margin-top: 10px;
}
</style>
